import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtomsModule } from './components/atoms/atoms.module';
import { MoleculesModule } from './components/molecules/molecules.module';
import { OrganismsModule } from './components/organisms/organisms.module';
import { PipesModule } from './pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    AtomsModule,
    MoleculesModule,
    OrganismsModule,
    PipesModule,
    MatTooltipModule
  ],
  exports: [
    AtomsModule,
    MoleculesModule,
    OrganismsModule,
    PipesModule,
    TranslateModule,
    MatTooltipModule
  ]
})
export class SharedModule { }
